import React, { useState, useEffect, useRef } from "react";
import { FiMenu } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { Row, Col, Offcanvas, Button } from "react-bootstrap";
import GreyTable from "../../../components/Tables/GreyTable";


import { format } from "date-fns";

import { GroupWiseSummery, resetGroupWiseSummery } from "../../../Redux/Slice/Grey/GreyDashboard/GreyDashboardSlice";
import { Loader } from "../../../components/Loader/Loader";
import { FilterBox } from "../../../components/FilterBox/FilterBox";
import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import { useTheme } from "../../../Themecontext/Themecontext";
import Calendar from "react-calendar";
import CommonCalendarStyle from "../../../components/Calendar/GreyCalenderCSS";

export const ProductiongroupInOut = () => {

  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");

  const dispatch = useDispatch();

  const [showFilter, setShowFilter] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const [showMonths, setShowMonths] = useState(false);
  const [showYears, setShowYears] = useState(false);

  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const years = Array.from(
    { length: 30 },
    (_, i) => new Date().getFullYear() - 15 + i
  );

  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { mainFilterData } = useSelector((state) => state.ClientLogin);
  const { GroupWiseSummerydata } = useSelector((state) => state.GreyDashboardSlice);

  console.log(mainFilterData);


  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW"
  );

  const { theme } = useTheme();
  const isdark = theme;


  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [showDatePicker, setShowDatePicker] = useState(false);

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);


  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!mainFilterData || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    mainFilterData?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [mainFilterData, FinancialYear]);


  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;


  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return null;
    return format(new Date(date), "yyyy-MM-dd");
  };



  useEffect(() => {
    dispatch(
      GroupWiseSummery({
        startDate: safeFormat(startDate, "yyyy-MM-dd"),
        endDate: safeFormat(endDate, "yyyy-MM-dd"),
      })
    );
  }, [dateRange]);



  const [filters, setFilters] = useState({
    production: [],
  });

  const [search, setSearch] = useState({
    production: "",
  });

  const productionGroups =
    mainFilterData?.production_Group_Master_List?.map((item) => ({
      label: item.ProductionGroupMstName,
      value: item.ProductionGroupMstID,
    })) || [];


  const toggleItem = (type, item) => {
    setFilters((prev) => {
      const selected = prev[type];

      const updatedItems = selected.includes(item.value)
        ? selected.filter((i) => i !== item.value)
        : [...selected, item.value];

      const updatedFilters = {
        ...prev,
        [type]: updatedItems,
      };

      dispatch(resetGroupWiseSummery());

      dispatch(
        GroupWiseSummery({
          startDate: safeFormat(startDate),
          endDate: safeFormat(endDate),
          groupIDs: updatedFilters.production.join(","),
        })
      );

      return updatedFilters;
    });
  };

  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [type]:
        prev[type].length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const handleClose = () => setShowFilter(false);
  const handleShow = () => setShowFilter(true);

  const tableData = (GroupWiseSummerydata?.data || []).map(
    (row, index) => ({
      // srNumber: index + 1,

      ProductionGroupMstName:
        row.ProductionGroupMstName?.trim() || "-",

      OpInwMeter: row.OpwMeter,
      InwMeter: row.InwMeter,
      FinishMeter: row.FinishMeter,
      TotalOutward: row.TotalOutward,
      BalMeter: row.BalanceMeter,
      ShortageMeter: row.ShortageMeter,
      LongeshionMeter: row.LongeshionMeter,
    })
  );

  const columns = [
    {
      label: "Sr No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: "Production Name",
      key: "ProductionGroupMstName",
      align: "left",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: `Opening Meter`,
      key: "OpInwMeter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
    {
      label: "Inward Meter",
      key: "InwMeter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
    {
      label: "Finish Meter",
      key: "FinishMeter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
    {
      label: "Shortage Meter",
      key: "ShortageMeter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
    {
      label: "Elongation Meter",
      key: "LongeshionMeter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
    {
      label: "Total Outward",
      key: "TotalOutward",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
    {
      label: "Balance Meter",
      key: "BalMeter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
  ];

  if (!mainFilterData) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }

  if (GroupWiseSummerydata === null) {
    return (
      <div className=" flex justify-center items-center h-screen text-xl " >
        <Loader />
      </div>
    );
  }



  return (


    <>


      <div className="pageContainer">

        <div xs={4} className="d-lg-none text-end mb-3">
          <Button
            onClick={handleShow}
            style={{
              border: "none",
              backgroundColor:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
              color:
                isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
            }}
          >
            <FiMenu size={22} />
          </Button>
        </div>


        <Offcanvas show={showFilter} onHide={handleClose} placement="start"
          style={{
            background:
              isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour10,
          }}
        >
          <Offcanvas.Header closeButton
            closeVariant={isdark === "dark" ? "white" : undefined}
            style={{ color: isdark === "light" ? "#000" : "#FFF", }}
          >
            <Offcanvas.Title>Filters</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div>
            <div
              style={{
                maxWidth: "100%",
                border: "1px solid rgb(183,228,199)",
                borderRadius: "12px",
                overflow: "hidden",
                backgroundColor:
                  isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour10,
                boxSizing: "border-box",
                marginBottom: "15px",
              }}
            >
              <div
                style={{
                  backgroundColor:
                    isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                  padding: "18px 22px",
                }}
              >
                <h3
                  style={{
                    fontWeight: "700",
                    fontSize: "18px",
                    margin: 0,
                    color:
                      isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                  }}
                >
                  Date Range
                </h3>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "12px 22px",
                }}
              >
                <div
                  onClick={() => setShowDatePicker(true)}
                  style={{
                    padding: "12px 12px",
                    borderRadius: "10px",
                    cursor: "pointer",
                    transition: "all 0.3s ease-in-out",
                    textAlign: "center",
                    backgroundColor:
                      isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour6,
                    color:
                      isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : "rgb(149 213 178 / 25%)"}`,
                    fontSize: "15px",
                    fontWeight: 500,
                    boxSizing: "border-box",
                  }}
                >
                  {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                    ? `${format(dateRange[0].startDate, "dd/MM/yyyy")} - ${format(dateRange[0].endDate, "dd/MM/yyyy")}`
                    : "Select Date Range"}
                </div>
              </div>
            </div>

            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <FilterBox
                title="Production Group"
                items={productionGroups}
                search={search.production}
                setSearch={(val) => handleSearch("production", val)}
                selectedItems={filters.production}
                toggleItem={(item) => toggleItem("production", item)}
                selectAll={() => selectAll("production", productionGroups)}
              />

            </div>
          </Offcanvas.Body>
        </Offcanvas>

        <Row className="g-4 align-items-start">
          <Col xl={3} lg={4} className="d-none d-lg-block">

            <div
              style={{
                maxWidth: "100%",
                border: "1px solid rgb(183,228,199)",
                borderRadius: "12px",
                overflow: "hidden",
                backgroundColor:
                  isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour10,
                boxSizing: "border-box",
                marginBottom: "15px",
              }}
            >
              <div
                style={{
                  backgroundColor:
                    isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                  padding: "18px 22px",
                }}
              >
                <h3
                  style={{
                    fontWeight: "700",
                    fontSize: "18px",
                    margin: 0,
                    color:
                      isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                  }}
                >
                  Date Range
                </h3>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "12px 22px",
                }}
              >
                <div
                  onClick={() => setShowDatePicker(true)}
                  style={{
                    padding: "12px 12px",
                    borderRadius: "10px",
                    cursor: "pointer",
                    transition: "all 0.3s ease-in-out",
                    textAlign: "center",
                    backgroundColor:
                      isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour6,
                    color:
                      isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : "rgb(149 213 178 / 25%)"}`,
                    fontSize: "15px",
                    fontWeight: 500,
                    boxSizing: "border-box",
                  }}
                >
                  {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                    ? `${format(dateRange[0].startDate, "dd/MM/yyyy")} - ${format(dateRange[0].endDate, "dd/MM/yyyy")}`
                    : "Select Date Range"}
                </div>
              </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <FilterBox
                title="Production Group"
                items={productionGroups}
                search={search.production}
                setSearch={(val) => handleSearch("production", val)}
                selectedItems={filters.production}
                toggleItem={(item) => toggleItem("production", item)}
                selectAll={() => selectAll("production", productionGroups)}
              />
            </div>


          </Col>
          <Col xl={9} lg={8} md={12} sm={12} style={{ minWidth: 0 }}>
            <div
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
              }}
            >
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour1,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour5
                      : iscolourDark?.Colour8,
                  padding: "14px",
                }}
              >
                <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px", fontWeight:"700" }}>
                  PRODUCTION GROUP IN OUT
                </h2>
              </div>
              <div>
                <GreyTable columns={columns} data={tableData} iscolourDark={iscolourDark}
                  iscolour={iscolour} />
              </div>
            </div>
          </Col>
        </Row>

      </div>
      {showDatePicker && (
        <>
          <CommonCalendarStyle
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 99999,
            }}
            onClick={() => setShowDatePicker(false)}
          >

            <div
              style={{
                background:
                  isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour7,

                borderRadius: "20px",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Calendar
                className="custom-calendar"
                selectRange={true}
                onChange={(value) => {
                  if (Array.isArray(value)) {
                    setDateRange([
                      {
                        startDate: value[0],
                        endDate: value[1],
                        key: "selection",
                      },
                    ]);
                  }
                }}
                value={
                  dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                    ? [dateRange[0].startDate, dateRange[0].endDate]
                    : null
                }
              />

              <div
                className="date-picker-footer"
                style={{
                  textAlign: "center",
                  marginTop: "15px",
                  padding: "12px",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour8
                      : iscolourDark?.Colour7,
                  borderRadius: "0 0 20px 20px",
                }}
              >
                <button
                  onClick={() => setShowDatePicker(false)}
                  style={{
                    padding: "10px",
                    borderRadius: "12px",
                    border: "none",
                    cursor: "pointer",
                    fontWeight: "700",
                    color: "#fff",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour6
                        : iscolourDark?.Colour3,
                    boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                    transition: "0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.opacity = "0.85";
                    e.target.style.transform = "scale(1.05)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.opacity = "1";
                    e.target.style.transform = "scale(1)";
                  }}
                >
                  Done
                </button>
              </div>
            </div>
          </div>
        </>
      )}

    </>

  );
};